import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloRemoveCardFromCalendarEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrelloRemoveCardFromCalendarEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plannerCalendarEventCardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plannerCalendarId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCardFromPlannerCalendarEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plannerCalendarEventCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plannerCalendarEventCardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plannerCalendarId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plannerCalendarId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"providerAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerAccountId"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"optIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"StringValue","value":"TrelloPlanner","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloRemoveCardFromCalendarEvent","document":TrelloRemoveCardFromCalendarEventDocument}} as const;
export type TrelloRemoveCardFromCalendarEventMutationVariables = Types.Exact<{
  plannerCalendarEventCardId: Types.Scalars['ID']['input'];
  plannerCalendarId: Types.Scalars['ID']['input'];
  providerAccountId: Types.Scalars['ID']['input'];
}>;


export type TrelloRemoveCardFromCalendarEventMutation = (
  { __typename: 'Mutation' }
  & { trello: (
    { __typename: 'TrelloMutationApi' }
    & { removeCardFromPlannerCalendarEvent?: Types.Maybe<(
      { __typename: 'TrelloRemoveCardFromPlannerCalendarEventPayload' }
      & Pick<Types.TrelloRemoveCardFromPlannerCalendarEventPayload, 'success'>
      & { errors?: Types.Maybe<Array<(
        { __typename: 'MutationError' }
        & Pick<Types.MutationError, 'message'>
      )>>, eventCard?: Types.Maybe<(
        { __typename: 'TrelloPlannerCalendarEventCardDeleted' }
        & Pick<Types.TrelloPlannerCalendarEventCardDeleted, 'id'>
      )> }
    )> }
  ) }
);

export type TrelloRemoveCardFromCalendarEventMutationFn =
  Apollo.MutationFunction<
    TrelloRemoveCardFromCalendarEventMutation,
    TrelloRemoveCardFromCalendarEventMutationVariables
  >;

/**
 * __useTrelloRemoveCardFromCalendarEventMutation__
 *
 * To run a mutation, you first call `useTrelloRemoveCardFromCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrelloRemoveCardFromCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trelloRemoveCardFromCalendarEventMutation, { data, loading, error }] = useTrelloRemoveCardFromCalendarEventMutation({
 *   variables: {
 *      plannerCalendarEventCardId: // value for 'plannerCalendarEventCardId'
 *      plannerCalendarId: // value for 'plannerCalendarId'
 *      providerAccountId: // value for 'providerAccountId'
 *   },
 * });
 */
export function useTrelloRemoveCardFromCalendarEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrelloRemoveCardFromCalendarEventMutation,
    TrelloRemoveCardFromCalendarEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrelloRemoveCardFromCalendarEventMutation,
    TrelloRemoveCardFromCalendarEventMutationVariables
  >(TrelloRemoveCardFromCalendarEventDocument, options);
}
export type TrelloRemoveCardFromCalendarEventMutationHookResult = ReturnType<
  typeof useTrelloRemoveCardFromCalendarEventMutation
>;
export type TrelloRemoveCardFromCalendarEventMutationResult =
  Apollo.MutationResult<TrelloRemoveCardFromCalendarEventMutation>;
export type TrelloRemoveCardFromCalendarEventMutationOptions =
  Apollo.BaseMutationOptions<
    TrelloRemoveCardFromCalendarEventMutation,
    TrelloRemoveCardFromCalendarEventMutationVariables
  >;
